import { useCallback, useState } from 'react';

import { IOrder, ShipmentResDataDto } from '@project44-models/shipment-list';

import { fetchRelatedShipments } from './fetchRelatedShipments';

function useRelatedShipments() {
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [data, setData] = useState<{
    order: IOrder;
    relatedShipments: ShipmentResDataDto;
  }>({
    order: {
      orderId: '',
    },
    relatedShipments: ShipmentResDataDto.fromJSON({
      paginationInfo: {},
      results: [],
    }),
  });

  const doFetch = useCallback(
    async (
      orderId: string,
      paging?: {
        page?: number;
        size?: number;
      },
    ) => {
      setIsError(false);
      setIsLoading(true);
      await fetchRelatedShipments({ orderId, paging })
        .then(({ order, relatedShipments }) => {
          setData({
            order,
            relatedShipments: ShipmentResDataDto.fromJSON(relatedShipments),
          });
          setIsLoading(false);
        })
        .catch(() => {
          setIsError(true);
          setIsLoading(false);
        });
    },
    [],
  );

  return {
    doFetch,
    data,
    isLoading,
    isError,
  };
}

export default useRelatedShipments;
